module.exports = __webpack_public_path__ + "img/bg.2c666b12.png";